// Used when the header_cart_button placeholder is missing (e.g. dropped by routing-service).
// A fresh object per call, so that mutations, getters and actions keep working and
// state.data stays reactive (Vuex would otherwise turn `false` into a non-reactive `{}`).
const emptyMiniCartState = () => ({
  data: {
    products: [],
    totalProductCount: 0,
  },
  component: null,
});

export const miniCartState = ({ data, component } = {}) => {
  if (!data) {
    return emptyMiniCartState();
  }

  return {
    data: {
      ...data.cart,
    },
    component,
  };
};
